import { render } from "./ModuleForm.vue?vue&type=template&id=2cfad39e"
import script from "./ModuleForm.vue?vue&type=script&lang=js"
export * from "./ModuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__